/**
 * This file contains constants that are used for fontAwesomeV6Icon
 */

/**
 * List of the available kit icons based on
 * https://fontawesome.com/kits/ea2d9d4413/customicons
 */
export const kitIcons = new Set([
  'ai-bot-regular',
  'ai-bot-solid',
  'ai-head-regular',
  'ai-head-solid',
  'ai-locked',
  'ai-off',
  'ai-sleeping',
  'ai-ta-head-solid',
  'ai-ta-tag',
  'clever',
  'click-to-continue-down',
  'click-to-continue-up',
  'connected-level',
  'duotone-solid-message-question-circle-exclamation',
  'move',
  'solid-bars-magnifying-glass',
  'solid-flask-sparkle',
  'solid-gear-pen',
  'solid-pen-sparkle',
  'solid-thumbtack-slash',
  'text-speech',
  'text-speech-pause',
]);
